import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Favorite, FavoriteBorder } from '@mui/icons-material';
import { Product } from '../types';
import { useFavorites } from '../context/FavoritesContext';
import { colors } from '../utils/constants';

interface FavoriteButtonProps {
  product: Product;
  size?: 'small' | 'medium' | 'large';
  color?: string;
  className?: string;
}

const FavoriteButton: React.FC<FavoriteButtonProps> = ({ 
  product, 
  size = 'medium', 
  color = colors.primary,
  className 
}) => {
  const { isFavorite, addToFavorites, removeProductFromFavorites } = useFavorites();
  const isProductFavorite = isFavorite(product.id);

  const handleToggleFavorite = async (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();

    if (isProductFavorite) {
      await removeProductFromFavorites(product.id);
    } else {
      await addToFavorites(product);
    }
  };

  return (
    <Tooltip title={isProductFavorite ? 'Remove from favorites' : 'Add to favorites'}>
      <IconButton
        onClick={handleToggleFavorite}
        size={size}
        className={className}
        sx={{
          color: isProductFavorite ? color : 'grey.400',
          '&:hover': {
            color: color,
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
          transition: 'all 0.2s ease-in-out',
        }}
      >
        {isProductFavorite ? <Favorite /> : <FavoriteBorder />}
      </IconButton>
    </Tooltip>
  );
};

export default FavoriteButton;
